import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import Fade from 'react-reveal/Fade';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  handleNewOrderCustomItemInput,
  removeColorSampleItem,
  removeNewOrderCustomItem,
  updateColorSampleItem,
} from 'services/store/actions/newOrder';
import ColorSampleType from './Cells/ColorSampleType';

const Input = styled.input`
  height: 28px;
  width: 100%;
  border-radius: 3px;
  border: 1px solid lightgray;
  &:focus {
    background-color: ${({ theme, focus }) =>
      focus ? theme.blowPrimaryLight : null};
  }
`;

const OrderCustomItemsRow = ({ item, index }) => {
  const dispatch = useDispatch();

  const handleItem = (value, field, isNumber = false) => {
    dispatch(updateColorSampleItem(index, field, value));
  };

  return (
    <>
      <Fade bottom>
        <tr>
          <td>{index + 1}</td>
          <td>
            <ColorSampleType
              handleChange={(e) => {
                handleItem(e.target.value, 'type');
              }}
              value={item.type}
            />
          </td>

          <td>
            <Input
              autoComplete="off"
              name="quantity"
              value={item.quantity}
              onChange={(e) => {
                handleItem(e.target.value, 'quantity', true);
              }}
              focus
            />
          </td>

          <td>
            <Input
              autoComplete="off"
              name="comments"
              value={item.comments}
              onChange={(e) => {
                handleItem(e.target.value, 'comments');
              }}
              focus
            />
          </td>
          <td
            onClick={() => dispatch(removeColorSampleItem(index))}
            style={{ color: '#c01212', cursor: 'pointer', width: 30 }}
          >
            <FontAwesomeIcon icon={faTimes} />
          </td>
        </tr>
      </Fade>
    </>
  );
};

export default OrderCustomItemsRow;
